import React from 'react';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import DatosResumen from './datosResumen';
// import FormularioDatosGenerales from './formularioDatosGenerales';

function DatosGeneralesCiudadano(props) {
    if(typeof props.dataRegistered != 'boolean') return "";
    return (
        <div>
             {/* <FormularioDatosGenerales {...props} />  */}
            {props.dataRegistered && ( <DatosResumen {...props}/> )
                // : ( <FormularioDatosGenerales {...props} /> )
            }
        </div>
    );
}

export default connect(mapStateToProps, null)(DatosGeneralesCiudadano);